import { Outlet } from '@remix-run/react';

import { OnboardingLayout } from '@shieldpay/bumblebee/layouts/onboarding';
import { Text } from '@shieldpay/bumblebee/text';

const AuthLayout = () => (
  <OnboardingLayout
    header={<Text color="currentColor">Logo placeholder</Text>}
    footer="Footer placeholder"
  >
    <Outlet />
  </OnboardingLayout>
);

export default AuthLayout;
